module.exports = __webpack_public_path__ + "static/img/cq-vfy.1039319.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/cq-vfy.png
// module id = QNIl
// module chunks = 1